import React from "react";
import ReactDOM from "react-dom";
import { getCurrentEmployeeBulkSession } from "../get-current-employee-bulk-session";
import { showErrorMessage } from "../../commons/show-error-message";
import { logError, addContextLog } from "../../../infrastructure/log";
import { translate } from "../../../infrastructure/translate/localization";
import EmployeesEditSummaryPage from "../components/employeesEditSummaryPage/EmployeesEditSummaryPage";

export function renderEmployeesEditSummaryPage({
  showTable,
  empsErrors,
  empsWarnings,
  empsModified,
  empsUnmodified,
  totalEmployees,
}) {
  ReactDOM.render(
    <EmployeesEditSummaryPage
      activeTable={showTable}
      employeesErrors={empsErrors}
      employeesWarnings={empsWarnings}
      employeesModified={empsModified}
      employeesUnmodified={empsUnmodified}
      employeesForUpload={empsWarnings.length + empsModified.length}
      employeesInFile={totalEmployees}
    />,
    document.getElementById("page-container")
  );
}

export async function displayEmployeesEditSummaryPage({
  employees = null,
  showTable = null,
}) {
  try {
    let currentEmployees;
    if (employees) {
      currentEmployees = employees;
    } else {
      currentEmployees = await getCurrentEmployeeBulkSession();
    }

    const empsErrors = currentEmployees["with-errors"];
    const empsWarnings = currentEmployees["with-warnings"];
    const empsModified = currentEmployees.modified;
    const empsUnmodified = currentEmployees.unmodified;
    const totalEmployees =
      empsErrors.length +
      empsWarnings.length +
      empsModified.length +
      empsUnmodified.length;

    renderEmployeesEditSummaryPage({
      showTable,
      empsErrors,
      empsWarnings,
      empsModified,
      empsUnmodified,
      totalEmployees,
    });
    addContextLog("info", "displayEmployeesEditSummaryPage", "display-screen");
  } catch (e) {
    logError(e, "Error to displayEmployeesEditSummaryPage");
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
